import { render, staticRenderFns } from "./UpdateSlider.vue?vue&type=template&id=4d9aaa28"
import script from "./UpdateSlider.vue?vue&type=script&lang=js"
export * from "./UpdateSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports